"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/Form/Popup.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);





















const generateBtnClass = (btnOption) =>
  _classBuilder2.default.call(void 0, 'popup--button', {
    'popup--button-enabled': !btnOption.disabled,
    'popup--button-disabled': btnOption.disabled,
  })

const preventClose = (evt) => {
  evt.stopPropagation()
}

const Popup = ({
  open,
  left,
  top,
  onClose,
  title,
  buttonOptions = [],
  onClick,
  children,
}) => {
  // The window listener lives for the component's lifetime (mount to
  // unmount, whether or not it is open) and always calls the latest onClose.
  const onCloseRef = _react.useRef.call(void 0, onClose)
  _react.useLayoutEffect.call(void 0, () => {
    onCloseRef.current = onClose
  })

  _react.useEffect.call(void 0, () => {
    const handleWindowClick = () => {
      onCloseRef.current()
    }
    window.addEventListener('click', handleWindowClick)
    return () => window.removeEventListener('click', handleWindowClick)
  }, [])

  const handleButtonClick = (btnOption) => {
    if (!btnOption.disabled) {
      _optionalChain([onClick, 'optionalCall', _ => _(btnOption.id)])
    }
  }

  if (!open) {
    return null
  }

  return (
    _react2.default.createElement('div', { className: "blmh-popup--screen", __self: this, __source: {fileName: _jsxFileName, lineNumber: 70}}
      , _react2.default.createElement('div', { className: "blmh-popup--container", style: { top, left }, onClick: preventClose, __self: this, __source: {fileName: _jsxFileName, lineNumber: 71}}
        , title && _react2.default.createElement('div', { className: "popup--title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 72}}, title)

        , children

        /* Tyler jesus christ why not just pass that as a child */
        , buttonOptions.map(b =>
          (_react2.default.createElement('div', { key: b.id, className: generateBtnClass(b), onClick: () => handleButtonClick(b), __self: this, __source: {fileName: _jsxFileName, lineNumber: 78}}
            , _react2.default.createElement('div', { className: "popup--button-text", __self: this, __source: {fileName: _jsxFileName, lineNumber: 79}}, b.text)
          )))

      )
    )
  )
}

exports. default = Popup
